'use client'

import { useLayoutEffect } from 'react'

function assertIframeFlag() {
  try {
    if (self !== top) {
      document.documentElement.setAttribute('data-in-iframe', '')
    }
  } catch {
    // If sandboxed/opaque origin prevents top access, we still assume iframe.
    document.documentElement.setAttribute('data-in-iframe', '')
  }
}

export default function IframeFlag() {
  useLayoutEffect(() => {
    assertIframeFlag()
  }, [])

  return null
}
